import React from "react";
import "./AnalyticsCardHeader.css";

interface AnalyticsCardHeaderProps {
  icon: React.ReactNode;
  title: string;
  subtitle: React.ReactNode;
  actions: React.ReactNode;
}

const AnalyticsCardHeader: React.FC<AnalyticsCardHeaderProps> = ({
  icon,
  title,
  subtitle,
  actions,
}) => (
  <div className="analytics-card-header">
    <h2 className="analytics-card-header__title">
      {icon}
      {title}
    </h2>
    <p className="analytics-card-header__subtitle">{subtitle}</p>
    <div className="analytics-card-header__actions">{actions}</div>
  </div>
);

export default AnalyticsCardHeader;
